"use client";
import t, { useRef as p, useMemo as n } from "react";
import "./index.es73.js";
import "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import "./index.es78.js";
import "./index.es79.js";
import "./index.es80.js";
import "./index.es81.js";
import "./index.es83.js";
import "./index.es84.js";
import "./index.es85.js";
import "./index.es86.js";
import "./index.es87.js";
import "./index.es88.js";
import "./index.es89.js";
import "./index.es90.js";
import l from "./index.es91.js";
import "./index.es92.js";
import E from "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import s from "styled-components";
import { getLegendElementId as c } from "./index.es97.js";
const d = s.div`
  ul {
    flex-wrap: wrap;
    max-width: 100%;
    li {
      padding: 0.5rem;
    }
  }
`, h = s.div`
  padding-top: 36px;
`, J = ({
  blockId: e,
  viewMode: r,
  chartData: i,
  chartOptions: o,
  currentUnits: a,
  title: u
}) => {
  const b = p(null), y = p(null), m = n(
    () => r !== "table" ? r : "bar",
    [r]
  ), f = n(
    () => a !== "Amount",
    [a]
  );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, r === "bar" && /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement(
    l,
    {
      key: `${e}-statistics-body-barchart`,
      type: m,
      data: i,
      options: o.screen,
      keyContext: `${e}-statistics-body-barchart`
    }
  ), /* @__PURE__ */ t.createElement(
    d,
    {
      ref: b,
      id: `${c(e, "bar")}`
    }
  )), r === "line" && /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement(
    l,
    {
      key: `${e}-statistics-body-linechart`,
      type: m,
      data: i,
      options: o.screen,
      keyContext: `${e}-statistics-body-linechart`
    }
  ), /* @__PURE__ */ t.createElement(
    d,
    {
      ref: y,
      id: `${c(e, "line")}`
    }
  )), r === "table" && /* @__PURE__ */ t.createElement(h, null, /* @__PURE__ */ t.createElement(
    E,
    {
      chartdata: i,
      parentId: e,
      isDecimal: f,
      caption: u
    }
  )));
};
export {
  J as default
};
//# sourceMappingURL=index.es279.js.map
